import React from 'react';
import { CustomComponentsProvider } from '@husky-x/gatsby-theme-husky';
import { HowItWorksMocks } from './custom-components-mocks';
import { HowItWorksOthersMocks } from './custom-components-mocks';
import { HowItWorksProductsMocks } from './custom-components-mocks';

import { HowItWorks } from '@husky-x/biofeeze-how-it-works';

export const wrapRootElement = ({ element }) => (
  <CustomComponentsProvider
    list={[
      {
        key: 'HowItWorks',
        component: () => <HowItWorks {...HowItWorksMocks} />,
      },
      {
        key: 'HowItWorksOthers',
        component: () => <HowItWorks {...HowItWorksOthersMocks} />,
      },
      {
        key: 'HowItWorksProducts',
        component: () => <HowItWorks {...HowItWorksProductsMocks} />,
      },
    ]}
  >
    {element}
  </CustomComponentsProvider>
);
